import { render, staticRenderFns } from "./CreatorRequests.vue?vue&type=template&id=3e8644a3&"
import script from "./CreatorRequests.vue?vue&type=script&lang=js&"
export * from "./CreatorRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports